
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: 'app',
components: {
XHeader
},
data () {
return {
showBackData: true
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue